import moment from "moment";
import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

import { openProfileDrawer } from "../../../../../../../actions/shared/uiActions";
import { makeGetFilteredContracts } from "../../../../../../../selectors/contractSelector";
import GlobalAvatar from "../../../../../../General/GlobalAvatar";
import LoadingPage from "../../../../../../General/LoadingPage";
import DrawerSortableTable from "../../../../../../General/SortableTable/DrawerSortableTable";
import RotatingEmptyState from "../../../../../../shared/EmptyState/RotatingEmptyState";
import EmployerCandidateDrawer from "../../../../../JobCasts/view/Candidates/view/CandidateDrawer";

const CONTRACT_WORK = "contract_work";
const NAME_COL = "nameCol";
const JOB_TITLE_COL = "jobTitleCol";
const LOCATION_COL = "locationCol";
const CONTRACT_START_COL = "contractStartCol";

const OpenContractTable = ({ recruiterId }) => {
  const dispatch = useDispatch();
  const getContracts = useMemo(makeGetFilteredContracts, []);
  const loaded = useSelector((state) => state.contracts.loaded);

  const openContracts = useSelector((state) =>
    getContracts(state, { open: true, recruiterId })
  );

  const openDataItems = openContracts.map((item) => item.attributes);
  const formatDate = (date) => moment(date).format("MMM D, YYYY");

  const openTableColumns = [
    {
      colKey: "AVATAR",
      label: "",
      renderData: ({ avatarIcon, firstName, lastName }) => (
        <GlobalAvatar
          individual={{
            avatarIcon,
            firstName,
            lastName,
          }}
        />
      ),
      style: { width: "6%" },
    },
    {
      colKey: NAME_COL,
      label: "Name",
      renderData: ({ candidateName, recruiterSubmissionId }) => {
        const handleClick = () => {
          dispatch(
            openProfileDrawer(
              <EmployerCandidateDrawer
                candidateId={recruiterSubmissionId}
                navSelection={CONTRACT_WORK}
              />
            )
          );
        };
        return (
          <div
            role="button"
            style={{
              color: "#008DAE",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            className="truncate psuedo-link"
            onClick={handleClick}
          >
            {candidateName}
          </div>
        );
      },
      orderFunc: ({ candidateName }) => candidateName.toLowerCase(),
      style: { width: "20%", justifyContent: "flex-start" },
    },
    {
      colKey: JOB_TITLE_COL,
      label: "Job Title",
      renderData: ({ jobTitle }) => <span>{jobTitle}</span>,
      orderFunc: ({ jobTitle }) => jobTitle.toLowerCase(),
      style: { width: "28%", justifyContent: "flex-start" },
    },
    {
      colKey: LOCATION_COL,
      label: "Location",
      renderData: ({ primaryWorkLocation }) => (
        <span>{primaryWorkLocation || "N/A"}</span>
      ),
      orderFunc: ({ primaryWorkLocation }) =>
        (primaryWorkLocation || "").toLowerCase(),
      style: { width: "20%", justifyContent: "flex-start" },
    },
    {
      colKey: CONTRACT_START_COL,
      label: "Contract Start",
      renderData: ({ scheduledStartDate }) => (
        <span>{formatDate(scheduledStartDate)}</span>
      ),
      orderFunc: ({ scheduledStartDate }) =>
        moment().diff(moment(scheduledStartDate)),
      style: { width: "26%", justifyContent: "center" },
    },
  ];

  return (
    <>
      {!loaded && <LoadingPage />}
      {loaded && openContracts.length > 0 && (
        <DrawerSortableTable columns={openTableColumns} items={openDataItems} />
      )}
      {loaded && openContracts.length === 0 && <RotatingEmptyState />}
    </>
  );
};

export default OpenContractTable;
